import _extends from '@babel/runtime/helpers/esm/extends';
import React, { memo, useState, useEffect } from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import Button from '@mui/material/Button';

const App = ({
  children,
  onClick,
  variant = 'contained',
  sx,
  disabled,
  color = 'primary',
  defaultText,
  isSubmitting: _isSubmitting = false,
  ...props
}) => {
  const [isSubmitting, setIsSubmitting] = useState(_isSubmitting);
  const _onClick = async e => {
    setIsSubmitting(true);
    if (onClick) await onClick(e);
    setIsSubmitting(false);
  };
  useEffect(() => {
    setIsSubmitting(_isSubmitting);
  }, [_isSubmitting]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, _extends({
    disabled: isSubmitting || disabled,
    onClick: _onClick,
    variant: variant,
    sx: {
      width: '100%',
      ...sx
    },
    color: color
  }, props), children || defaultText || 'Submit'), isSubmitting && /*#__PURE__*/React.createElement(LinearProgress, null));
};
const SubmitButton = /*#__PURE__*/memo(App);

export { SubmitButton };
